import * as React from "react";

import { cn } from "../cn";

/**
 * The chart palette and the marker that carries it into tables, cards and line items. Separate
 * from chartCommon so the tooltip can use the same marker without the two importing each other.
 */

// One colour per row, shared by a marker/card accent and its chart series so the two read as the
// same thing. A chart palette, deliberately not the semantic sentiment colours.
export const SERIES = [
  { dot: "bg-blue-500", stroke: "#3b82f6" },
  { dot: "bg-emerald-500", stroke: "#10b981" },
  { dot: "bg-amber-500", stroke: "#f59e0b" },
  { dot: "bg-violet-500", stroke: "#8b5cf6" },
];

export function seriesColor(rowIndex: number) {
  return SERIES[rowIndex % SERIES.length];
}

const MARKER = "h-2.5 w-2.5 shrink-0 rounded-sm";

/**
 * The colour marker tying a row, card or line item to its chart series. `color` overrides the
 * palette for the chart tooltip, which is handed a colour by recharts rather than a row index.
 */
export function SeriesDot({
  index,
  color,
  className,
}: {
  index?: number;
  color?: string;
  className?: string;
}) {
  return (
    <span
      className={cn(
        MARKER,
        index !== undefined && !color ? seriesColor(index).dot : undefined,
        className
      )}
      style={color ? { backgroundColor: color } : undefined}
    />
  );
}

/** Hollow, not filled — the "not solid yet" cue for cash no configured plan funds. */
export function HollowSeriesDot({ className }: { className?: string }) {
  return (
    <span className={cn(MARKER, "border-2 border-amber-500", className)} />
  );
}
